import gsap from 'gsap'

class HamburgerMenu {
  constructor() {
    this.button = document.getElementsByClassName('hamburger-button')[0]
    this.barTop = this.button.getElementsByClassName(
      'hamburger-button__bar_top'
    )[0]
    this.barMiddle = this.button.getElementsByClassName(
      'hamburger-button__bar_middle'
    )[0]
    this.barBottom = this.button.getElementsByClassName(
      'hamburger-button__bar_bottom'
    )[0]
    this.menu = document.getElementsByClassName('hamburger-menu')[0]
    this.state = false
    this.links = this.menu.querySelectorAll(`.hamburger-menu__link`)
    this.charMain = this.menu.querySelectorAll('.hamburger-menu__char-main')
    this.charSub = this.menu.querySelectorAll('.hamburger-menu__char-sub')

    gsap.set(this.menu, {
      autoAlpha: 0,
    })

    this.button.addEventListener('click', () =>
      this.state ? this.close() : this.open()
    )

    this.links.forEach((link) => {
      link.addEventListener('click', () => this.close())
    })
  }

  open() {
    const bar = gsap.timeline()
    bar
      .to(this.barTop, {
        yPercent: -50,
        rotate: 35,
        top: '50%',
      })
      .to(
        this.barBottom,
        {
          yPercent: 50,
          bottom: '50%',
          rotate: -35,
        },
        '<'
      )
      .to(
        this.barMiddle,
        {
          scaleX: 0,
        },
        '<'
      )

    const menu = gsap.timeline({ defaults: { overwrite: false } })
    menu
      .fromTo(
        this.menu,
        {
          clipPath: 'inset(100% 0 0 0)',
          autoAlpha: 1,
        },
        {
          ease: 'expo.out',
          clipPath: 'inset(0% 0 0 0)',
          onComplete: () => (this.state = true),
        }
      )
      .fromTo(
        this.charMain,
        {
          yPercent: 100,
        },
        {
          yPercent: 0,
          duration: 1.0,
          ease: 'expo.out',
          stagger: 0.1,
        },
        '<+0.1'
      )
      .fromTo(
        this.charSub,
        {
          yPercent: 100,
        },
        {
          yPercent: 0,
          duration: 1.0,
          ease: 'expo.out',
          stagger: 0.1,
        },
        '<+0.1'
      )
      .fromTo(
        '.hamburger-menu__top-bar',
        {
          xPercent: -100,
          filter: 'brightness(0.8) blur(0.5px)',
        },
        {
          xPercent: 0,
          filter: 'brightness(1) blur(0px)',
          duration: 2.5,
          ease: 'cubic.out',
        },
        '<-0.2'
      )
      .fromTo(
        '.hamburger-menu__under-bar',
        {
          xPercent: -100,
          filter: 'brightness(0.8) blur(0.5px)',
        },
        {
          xPercent: 0,
          filter: 'brightness(1) blur(0px)',
          duration: 2.5,
          ease: 'cubic.out',
          stagger: 0.1,
        },
        '<+0.1'
      )
  }

  close() {
    const bar = gsap.timeline()

    bar
      .to(this.barTop, {
        yPercent: 0,
        top: '0%',
        rotate: 0,
      })
      .to(
        this.barBottom,
        {
          yPercent: 0,
          bottom: '0%',
          rotate: 0,
        },
        '<'
      )
      .to(
        this.barMiddle,
        {
          scaleX: 1,
        },
        '<'
      )

    gsap.to(this.menu, {
      autoAlpha: 0,
      ease: 'quad.in',
      onComplete: () => (this.state = false),
    })
  }
}

export default HamburgerMenu
